// src/pages/ItemAdjustment/itemAdjustmentThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAdjustmentVoucherNumberApi,
  createAdjustmentApi,
  updateAdjustmentApi,
} from "../../apiservice/inventory"; // <-- adjust path if different
import { getBatchApi } from "../../apiservice/accounts";
import { getCurrentStockApi, getBatchSerialsApi } from "../../apiservice/sales";
import dayjs from "dayjs";
import { formatToUtc, getDateTimeFromSelectedDate } from "../../lib/functions";

// src/pages/ItemAdjustment/itemAdjustmentThunk.js

// src/pages/ItemAdjustment/itemAdjustmentThunk.js

// const validateTatmeenAdjustment = (itemsList, isTatmeenProduct, authInfo) => {
//   const errors = [];
//   const isTatmeenEnabled = authInfo?.is_tatmeen_enabled === "yes" &&
//     authInfo?.country === "United Arab Emirates";

//   console.log("🔍 Validation called with:", {
//     isTatmeenEnabled,
//     isTatmeenProduct,
//     itemsCount: itemsList.length
//   });

//   // ✅ Only validate if Tatmeen is enabled in UAE
//   if (!isTatmeenEnabled) {
//     console.log("⏭️ Tatmeen not enabled, skipping validation");
//     return { valid: true, errors: [] };
//   }

//   // ✅ If Tatmeen is not enabled for the product, check if serials are selected
//   if (!isTatmeenProduct) {
//     for (const item of itemsList) {
//       if (!item.item_id) continue;
//       const hasSerials = item.serials && item.serials.length > 0;
//       if (hasSerials) {
//         errors.push({
//           item: item.product || 'Unknown Item',
//           message: `Serials selected for "${item.product || 'Unknown Item'}" but Tatmeen is not enabled. Please enable Tatmeen or clear the serials.`
//         });
//       }
//     }
//     return {
//       valid: errors.length === 0,
//       errors: errors
//     };
//   }

//   // ✅ Tatmeen is enabled - validate all items
//   for (const item of itemsList) {
//     // Skip empty rows
//     if (!item.item_id) continue;

//     const hasSerials = item.serials && item.serials.length > 0;
//     const hasQuantity = Number(item.quantity || 0) > 0;
//     const hasBatchId = !!item.batch_id;
//     const isDamageType = item.adjustment_type === "damage_stock";

//     console.log(`🔍 Validating item: ${item.product}`, {
//       hasQuantity,
//       quantity: item.quantity,
//       hasSerials,
//       serialCount: item.serials?.length || 0,
//       serialMode: item.serial_mode,
//       hasBatchId
//     });

//     // Skip items with no quantity (they don't need validation)
//     if (!hasQuantity) {
//       console.log(`⏭️ Skipping ${item.product} - no quantity`);
//       continue;
//     }

//     // ============================================================
//     // VALIDATION 1: If Tatmeen checked, each product must have batch_id
//     // ============================================================
//     if (!hasBatchId) {
//       errors.push({
//         item: item.product || 'Unknown Item',
//         message: `"${item.product || 'Unknown Item'}" has Tatmeen enabled but no batch selected. Please select a batch.`
//       });
//       console.log(`❌ ${item.product} - No batch selected`);
//       continue;
//     }

//     // ============================================================
//     // VALIDATION 2: If Tatmeen checked, each product must have serials
//     // ============================================================
//     if (!hasSerials) {
//       errors.push({
//         item: item.product || 'Unknown Item',
//         message: `"${item.product || 'Unknown Item'}" has Tatmeen enabled but no serials selected. Please select serials.`
//       });
//       console.log(`❌ ${item.product} - No serials selected`);
//       continue;
//     }

//     // ============================================================
//     // VALIDATION 3: Serial count must match quantity
//     // ============================================================
//     const serialCount = item.serials.length;
//     const quantity = Number(item.quantity || 0);

//     console.log(`🔍 ${item.product}: serialCount=${serialCount}, quantity=${quantity}, serial_mode=${item.serial_mode}`);

//     if (item.serial_mode === "unit") {
//       // ✅ Unit mode: serial count must equal quantity
//       if (serialCount !== quantity) {
//         const errorMsg = `"${item.product || 'Unknown Item'}" has ${serialCount} serial(s) selected but quantity is ${quantity}. Please select exactly ${quantity} serial(s).`;
//         console.log(`❌ ${item.product} - ${errorMsg}`);
//         errors.push({
//           item: item.product || 'Unknown Item',
//           message: errorMsg
//         });
//       } else {
//         console.log(`✅ ${item.product} - Serial count matches quantity`);
//       }
//     } else if (item.serial_mode === "batch") {
//       // ✅ Batch mode: serial count must be exactly 1
//       if (serialCount !== 1) {
//         const errorMsg = `"${item.product || 'Unknown Item'}" is in Batch Serial Mode. Please select exactly 1 batch serial.`;
//         console.log(`❌ ${item.product} - ${errorMsg}`);
//         errors.push({
//           item: item.product || 'Unknown Item',
//           message: errorMsg
//         });
//       } else {
//         console.log(`✅ ${item.product} - Batch mode has exactly 1 serial`);
//       }
//     }

//     // ============================================================
//     // VALIDATION 4: For damage type, serials must be selected
//     // ============================================================
//     if (isDamageType && !hasSerials) {
//       errors.push({
//         item: item.product || 'Unknown Item',
//         message: `"${item.product || 'Unknown Item'}" is marked as damage but no serials selected. Please select serials for damaged items.`
//       });
//     }
//   }

//   console.log(`📊 Validation complete: ${errors.length} errors found`);
//   if (errors.length > 0) {
//     console.log("❌ Errors:", errors);
//   }

//   return {
//     valid: errors.length === 0,
//     errors: errors
//   };
// };

// src/pages/ItemAdjustment/itemAdjustmentThunk.js

const validateTatmeenAdjustment = (itemsList, isTatmeenProduct, authInfo) => {
  const errors = [];
  const isTatmeenEnabled = authInfo?.is_tatmeen_enabled === "yes" &&
    authInfo?.country === "United Arab Emirates";

  if (!isTatmeenEnabled) {
    return { valid: true, errors: [] };
  }

  if (!isTatmeenProduct) {
    for (const item of itemsList) {
      if (!item.item_id) continue;
      const hasSerials = item.serials && item.serials.length > 0;
      if (hasSerials) {
        errors.push({
          item: item.product || 'Unknown Item',
          message: `Serials selected for "${item.product || 'Unknown Item'}" but Tatmeen is not enabled.`
        });
      }
    }
    return { valid: errors.length === 0, errors: errors };
  }

  for (const item of itemsList) {
    if (!item.item_id) continue;

    const hasSerials = item.serials && item.serials.length > 0;
    const hasQuantity = Number(item.quantity || 0) > 0;
    const hasBatchId = !!item.batch_id;

    if (!hasQuantity) continue;

    if (!hasBatchId) {
      errors.push({
        item: item.product || 'Unknown Item',
        message: `"${item.product || 'Unknown Item'}" has Tatmeen enabled but no batch selected.`
      });
      continue;
    }

    if (!hasSerials) {
      errors.push({
        item: item.product || 'Unknown Item',
        message: `"${item.product || 'Unknown Item'}" has Tatmeen enabled but no serials selected.`
      });
      continue;
    }

    const serialCount = item.serials.length;
    const quantity = Number(item.quantity || 0);

    if (item.serial_mode === "unit") {
      // ✅ Unit mode: serial count must equal quantity
      if (serialCount !== quantity) {
        errors.push({
          item: item.product || 'Unknown Item',
          message: `"${item.product || 'Unknown Item'}" has ${serialCount} serial(s) selected but quantity is ${quantity}. Please select exactly ${quantity} serial(s).`
        });
      }
    } else if (item.serial_mode === "batch") {
      // ✅ BATCH MODE: Must have exactly 1 serial
      if (serialCount !== 1) {
        errors.push({
          item: item.product || 'Unknown Item',
          message: `"${item.product || 'Unknown Item'}" is in Batch Serial Mode. Please select exactly 1 batch serial.`
        });
      }
      // ✅ For batch mode, quantity can be 0 or full batch quantity
      // No validation needed - user can choose 0 or full quantity
      // But if quantity is not 0, it should equal the available quantity
      const fullQty = Number(item.available_qty || 0);
      if (quantity !== 0 && quantity !== fullQty) {
        errors.push({
          item: item.product || 'Unknown Item',
          message: `"${item.product || 'Unknown Item'}" is in Batch Serial Mode. Quantity must be either 0 or ${fullQty}.`
        });
      }
    }
  }

  return {
    valid: errors.length === 0,
    errors: errors
  };
};

export const fetchAdjustmentVoucherNo = createAsyncThunk(
  "itemAdjustment/fetchAdjustmentVoucherNo",
  async () => {
    const res = await getAdjustmentVoucherNumberApi();
    return res.data;
  }
);

export const fetchStockForItem = createAsyncThunk(
  "itemAdjustment/fetchStockForItem",
  async ({ itemId, warehouseId }) => {
    const res = await getCurrentStockApi({ itemId, warehouseId });
    return { itemId, data: res.data[0] };
  }
);

export const fetchBatchesForItem = createAsyncThunk(
  "itemAdjustment/fetchBatchesForItem",
  async ({ itemId, isEdit = false, adjustId = 0 }) => {
    const payload = {
      item_id: itemId,
      item_qty: 1,
    };
    if (isEdit) {
      payload.adjustment_edit = 1;
      payload.item_qty = 0;
       payload.adjust_id = adjustId;
    }
    const res = await getBatchApi(payload);
    return {
      itemId,
      data: (res.data || []).map((b) => ({
        id: b.id,
        batch_name: b.batch_name,
        quantity: b.quantity,
        rate: b.rate,
        serial_mode: b.serial_mode || "unit",
      })),
    };
  }
);

export const createItemAdjustment = createAsyncThunk(
  "itemAdjustment/createItemAdjustment",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const adjustmentState = state.itemAdjustment;
      const authInfo = state.auth?.auth_info || state.auth?.user || {}; // Adjust based on your auth slice structure
      console.log(authInfo, "authInfo1212");

      // ✅ Log the items for debugging
      console.log("📦 Items being validated:", adjustmentState.itemsList.map(item => ({
        product: item.product,
        quantity: item.quantity,
        serial_mode: item.serial_mode,
        serials: item.serials,
        serialsCount: item.serials?.length || 0
      })));

      // ✅ Run Tatmeen validation
      const tatmeenValidation = validateTatmeenAdjustment(
        adjustmentState.itemsList,
        adjustmentState.isTatmeenProduct,
        authInfo
      );

      console.log("✅ Tatmeen Validation Result:", tatmeenValidation);

      if (!tatmeenValidation.valid) {
        const errorMessages = tatmeenValidation.errors.map((e, index) =>
          `${index + 1}. ${e.message}`
        ).join('\n');

        return rejectWithValue({
          message: `Tatmeen Validation Failed:\n${errorMessages}`,
          errors: tatmeenValidation.errors,
          details: tatmeenValidation.errors
        });
      }

      // ✅ Check if authInfo exists and has the required properties
      const isMinusStockSale = authInfo?.is_minus_stock_sale || false;
      const isTatmeenEnabled = authInfo?.is_tatmeen_enabled || false;

      if (!adjustmentState.itemsList || !adjustmentState.itemsList.length) {
        return rejectWithValue({ message: "Cart is empty" });
      }

      // ✅ Get all available batches and stock info from state
      const batches = adjustmentState.batches || {};
      const stock = adjustmentState.stock || {};


      for (const item of adjustmentState.itemsList) {
        if (!item.item_id) {
          return rejectWithValue({
            message: "Please select an item for all rows."
          });
        }

        // Check for negative quantity
        if (item.quantity < 0) {
          return rejectWithValue({
            message: `Quantity cannot be negative for ${item.product || 'item'}`
          });
        }

        // For add_stock, ensure quantity > 0
        if (item.adjustment_type === "add_stock" && item.quantity <= 0) {
          return rejectWithValue({
            message: `Quantity must be greater than 0 for ${item.product || 'item'}`
          });
        }

        // For damage_stock with no minus stock sale, check individual max
        if (item.adjustment_type === "damage_stock" && !isMinusStockSale) {
          const maxQty = item.batch_id
            ? Number(item.available_qty || 0)
            : Number(item.loose_qty || 0);

          if (item.quantity > maxQty) {
            return rejectWithValue({
              message: `Insufficient stock for ${item.product || 'item'}`,
              details: [{
                item_name: item.product || 'item',
                available: maxQty,
                requested: item.quantity
              }]
            });
          }
        }
      }

      // ✅ VALIDATION 2: Check total quantities across rows (critical missing validation)
      // Group by (item_id, batch_id) to check total allocations
      const allocationMap = new Map();

      for (const item of adjustmentState.itemsList) {
        // Skip rows with no item or zero quantity
        if (!item.item_id || item.quantity <= 0 || item.adjustment_type === "add_stock") continue;

        // Create a unique key: itemId + batchId (null for no batch)
        const key = `${item.item_id}_${item.batch_id || 'no_batch'}`;

        if (!allocationMap.has(key)) {
          allocationMap.set(key, {
            item_id: item.item_id,
            batch_id: item.batch_id || null,
            total_quantity: 0,
            product: item.product || 'item',
            rows: []
          });
        }

        const entry = allocationMap.get(key);
        entry.total_quantity += Number(item.quantity);
        entry.rows.push(item);
      }

      // ✅ Check each group against available quantity
      for (const [key, group] of allocationMap) {
        const { item_id, batch_id, total_quantity, product } = group;

        if (batch_id) {
          // ✅ Batch selected - check against batch quantity
          const itemBatches = batches[item_id] || [];
          const selectedBatch = itemBatches.find(b => b.id === batch_id);

          if (!selectedBatch) {
            return rejectWithValue({
              message: `Batch not found for ${product}`
            });
          }

          const availableQty = Number(selectedBatch.quantity || 0);

          // For Tatmeen batch mode, each row should already be restricted
          // But still check total across rows
          if (total_quantity > availableQty) {
            // Check if it's a Tatmeen batch mode (serial_mode === "batch")
            if (selectedBatch.serial_mode === "batch" && isTatmeenEnabled) {
              // This shouldn't happen because quantity field is disabled
              // But just in case, show a specific error
              return rejectWithValue({
                message: `Batch "${selectedBatch.batch_name}" has serial mode "batch". Partial quantity adjustment is not allowed.`,
                details: [{
                  item_name: product,
                  batch: selectedBatch.batch_name,
                  available: availableQty,
                  requested: total_quantity
                }]
              });
            }

            // For unit mode, show total exceeds available
            return rejectWithValue({
              message: `Total quantity (${total_quantity}) exceeds available quantity (${availableQty}) for batch "${selectedBatch.batch_name}" of ${product}`,
              details: [{
                item_name: product,
                batch: selectedBatch.batch_name,
                available: availableQty,
                requested: total_quantity
              }]
            });
          }
        } else {
          // ✅ No batch selected - check against loose_qty
          const stockInfo = stock[item_id];
          if (!stockInfo) {
            return rejectWithValue({
              message: `Stock information not found for ${product}`
            });
          }

          const looseQty = Number(stockInfo.loose_qty || 0);

          // Total quantity across all rows without batch must not exceed loose_qty
          if (total_quantity > looseQty) {
            return rejectWithValue({
              message: `Total quantity (${total_quantity}) exceeds available loose quantity (${looseQty}) for ${product}`,
              details: [{
                item_name: product,
                available: looseQty,
                requested: total_quantity
              }]
            });
          }
        }
      }

      // ✅ All validations passed, proceed with submission

      // convert selected/entry Date to utc date + time
      let finalEntryDate = adjustmentState.entryDate;
      if (!dayjs(adjustmentState.entryDate).isSame(dayjs(), "day")) {
        finalEntryDate = getDateTimeFromSelectedDate(adjustmentState.entryDate);
      } else {
        finalEntryDate = adjustmentState.entryDate;
      }

      const itemCart = adjustmentState.itemsList.map((it) => ({
        adjust_qty: Number(it.quantity || 0),
        adjust_rate: Number(it.rate || 0),
        adjust_type: it.adjustment_type,
        base_unit_name: it.base_unit_name || "",
        conversion: it.conversion || 1,
        display_text: it.product || it.display_text || "",
        is_serial: it.is_serial || "no",
        item_id: it.item_id,
        item_name: it.product,
        item_qty: Number(it.quantity || 0),
        item_rate: Number(it.rate || 0),
        item_total: Number((it.quantity || 0) * (it.rate || 0)).toFixed(2),
        per_conversion: it.per_conversion || 1,
        per_unit_id: it.unit_id || 0,
        per_unit_symbol: it.unit_symbol || "",
        retail_qty: it.retail_qty || 0,
        unit_symbol: it.unit_symbol || "",
        unit_name: it.unit_name || "",
        warehouse_id: it.from_warehouse_id || 0,
        warehouse_name: it.from_warehouse_name || "",
        batch_id: it.batch_id || 0,
        serial_mode: it.serial_mode || "unit",
        serials: it.serials || [],
      }));

      const masterData = {
        voucher_no: adjustmentState.voucherNo,
        is_serial: itemCart.some((i) => i.is_serial === "yes") ? "yes" : "no",
        narration: adjustmentState.footerValues?.narration || "",
        sub_total: adjustmentState.footerValues?.total || 0,
        total_amount: adjustmentState.footerValues?.total || 0,
        created_date: formatToUtc(finalEntryDate),
      };

      const payload = {
        adjust_id: adjustmentState.a_id || 0,
        masterData,
        itemCart,
        is_tatmeen_product: adjustmentState.isTatmeenProduct,
      };

      const res = await (
        adjustmentState.a_id && adjustmentState.a_id !== 0
          ? updateAdjustmentApi(payload)
          : createAdjustmentApi(payload)
      );

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message });
    }
  }
);

export const fetchBatchSerials = createAsyncThunk(
  "itemAdjustment/fetchBatchSerials",
  async ({ itemId, batchId, isEdit = false }) => {

    const payload = {
      item_id: itemId,
      batch_id: batchId,
    };
    if (isEdit) {
      payload.adjustment_edit = 1;
    }
    const res = await getBatchSerialsApi(payload);


    return {
      batchId,
      data: res.data,
    };
  }
);

// export const createItemAdjustment = createAsyncThunk(
//   "itemAdjustment/createItemAdjustment",
//   async (_, { getState, rejectWithValue }) => {

//     try {
//       const state = getState().itemAdjustment;
//       if (!state.itemsList || !state.itemsList.length) {
//         return rejectWithValue({ message: "Cart empty" });
//       }

//       for (const item of state.itemsList) {
//         if (!item.item_id) {
//           return rejectWithValue({ message: "Please select an item for all rows." });
//         }

//         // ✅ Check quantity based on rules
//         if (item.adjustment_type === "damage_stock") {
//           const maxQty = item.batch_id
//             ? Number(item.available_qty || 0)
//             : Number(item.loose_qty || 0);

//           if (item.quantity > maxQty && !getState().auth.is_minus_stock_sale) {
//             return rejectWithValue({
//               message: `Insufficient stock for ${item.product}`,
//               details: [{
//                 item_name: item.product,
//                 available: maxQty,
//                 requested: item.quantity
//               }]
//             });
//           }
//         }
//       }

//       // convert selected/entry Date to utc date + time
//       let finalEntryDate = state.entryDate;
//       if (!dayjs(state.entryDate).isSame(dayjs(), "day")) {
//         finalEntryDate = getDateTimeFromSelectedDate(state.entryDate); // Merge date + current time in TZ

//       } else {
//         finalEntryDate = state.entryDate; // Use now in TZ
//       }

//       const itemCart = state.itemsList.map((it) => ({
//         adjust_qty: Number(it.quantity || 0),
//         adjust_rate: Number(it.rate || 0),
//         adjust_type: it.adjustment_type,
//         base_unit_name: it.base_unit_name || "",
//         conversion: it.conversion || 1,
//         display_text: it.product || it.display_text || "",
//         is_serial: it.is_serial || "no",
//         item_id: it.item_id,
//         item_name: it.product,
//         item_qty: Number(it.quantity || 0),
//         item_rate: Number(it.rate || 0),
//         item_total: Number((it.quantity || 0) * (it.rate || 0)).toFixed(2),
//         per_conversion: it.per_conversion || 1,
//         per_unit_id: it.unit_id || 0,
//         per_unit_symbol: it.unit_symbol || "",
//         retail_qty: it.retail_qty || 0,
//         unit_symbol: it.unit_symbol || "",
//         unit_name: it.unit_name || "",
//         warehouse_id: it.from_warehouse_id || 0,
//         warehouse_name: it.from_warehouse_name || "",
//         batch_id: it.batch_id || 0,
//         serials: it.serials || [],
//       }));

//       const masterData = {
//         voucher_no: state.voucherNo,
//         is_serial: itemCart.some((i) => i.is_serial === "yes") ? "yes" : "no",
//         narration: state.footerValues?.narration || "",
//         sub_total: state.footerValues?.total || 0,
//         total_amount: state.footerValues?.total || 0,
//         created_date: formatToUtc(finalEntryDate),
//       };

//       const payload = {
//         adjust_id: state.a_id || 0,
//         masterData,
//         itemCart,
//       };

//       const res = await (
//         state.a_id && state.a_id !== 0
//           ? updateAdjustmentApi(payload)
//           : createAdjustmentApi(payload)
//       );


//       return res.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || { message: err.message });
//     }
//   }
// );
